import { ISuperscriptStyle } from '../models/index.js';
export const superscriptStyle: ISuperscriptStyle = {
	font: {
		weight: '800',
	},
	color: '#000',
};
